// Reserved backend coordinates for the fixed "home" holes around the temple.
export const HOME_HOLE_COORDS: Record<string, [number, number]> = {
  home_t1: [-9001, -9001],
  home_t2: [-9000, -9001],
  home_t3: [-8999, -9001],
  home_b1: [-9001, -9000],
  home_b2: [-9000, -9000],
  home_b3: [-8999, -9000],
};

// Coordinates used by the Firestore migration script (legacy data).
export const LEGACY_HOME_HOLE_COORDS: Record<string, [number, number]> = {
  home_t1: [-1, -99],
  home_t2: [0, -99],
  home_t3: [1, -99],
  home_b1: [-1, 99],
  home_b2: [0, 99],
  home_b3: [1, 99],
};

const COORD_TO_HOLE_ID = new Map<string, string>();

for (const [holeId, [x, y]] of Object.entries(HOME_HOLE_COORDS)) {
  COORD_TO_HOLE_ID.set(`${x},${y}`, holeId);
}
for (const [holeId, [x, y]] of Object.entries(LEGACY_HOME_HOLE_COORDS)) {
  if (!COORD_TO_HOLE_ID.has(`${x},${y}`)) {
    COORD_TO_HOLE_ID.set(`${x},${y}`, holeId);
  }
}

export function holeIdFromCoords(x: number, y: number): string {
  return COORD_TO_HOLE_ID.get(`${x},${y}`) ?? `${x},${y}`;
}

export function coordsFromHoleId(holeId: string): [number, number] {
  if (holeId.startsWith("home_")) {
    return HOME_HOLE_COORDS[holeId] ?? [0, 0];
  }
  const parts = holeId.split(",");
  const gx = parseInt(parts[0], 10);
  const gy = parseInt(parts[1], 10);
  return [isNaN(gx) ? 0 : gx, isNaN(gy) ? 0 : gy];
}
